import { render, staticRenderFns } from "./aboutCase.vue?vue&type=template&id=1face843&scoped=true&"
import script from "./aboutCase.vue?vue&type=script&lang=js&"
export * from "./aboutCase.vue?vue&type=script&lang=js&"
import style0 from "./aboutCase.vue?vue&type=style&index=0&id=1face843&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1face843",
  null
  
)

export default component.exports